import { ArrayCompositionPipeableTree } from '../base/pipeable/array_composition_pipeable_tree.js';

class ChecklistPipeables {
  get editableItems() {
    if (!this.#editableItems) {
      this.#editableItems = new ArrayCompositionPipeableTree(
        this.#caster,
        () => this.#caster.editableItems,
        [],
        '[Array:ChecklistEditableItems]'
      );
    }
    return this.#editableItems;
  }

  get packItems() {
    if (!this.#packItems) {
      this.#packItems = new ArrayCompositionPipeableTree(
        this.#caster,
        () => this.#caster.packItems,
        [],
        '[Array:ChecklistPackItems]'
      );
    }
    return this.#packItems;
  }

  constructor(caster) {
    this.#caster = caster;
  }

  #caster;

  #packItems;
  #editableItems;
}

export { ChecklistPipeables };
